<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-body">
      <div class="container">
        <h1 class="title has-text-centered">
          Activating your account
        </h1>
        <h2 class="subtitle">
          <p class="has-text-centered spinner"><img src="/static/img/others/spinner.svg" alt="Activating your account..." /></p>
        </h2>
      </div>
    </div>
  </section>
</template>
<script>
  import qs from 'qs'
  import axios from 'axios'

  export default {
    name: 'ActivatingAccount',
    data () {
      return {
        activation_token: ''
      }
    },
    created () {
      this.activateUser()
    },
    methods: {
      activateUser () {
        if (this.$route.query.token && this.$route.query.token.length > 0) {
          this.activation_token = this.$route.query.token
          axios.post(`/consumer/user/activate`, { token: this.activation_token, uuid: this.$route.query.uuid} )
            .then(({data}) => {
              localStorage.setItem('auth_token', data.token)
              localStorage.setItem('profile_id', data.profile_id)
              localStorage.setItem('mobile', data.mobile)
              localStorage.setItem('displayName', data.displayName)
              localStorage.setItem('avatar', data.avatar)
              this.$gtm.trackEvent({
                event: 'conversionSuccess',
                type: 'AccountActivation'
              })
              this.$router.push('/')
            })
            .catch(({response}) => {
              const data = response.data
              this.redirectWithMessage('/login', data.message, data.success, data.uuid)
            })
        } else {
          this.redirectWithMessage('/login', 'You tried accessing an expired link. Please login to continue')
        }
      },
      /**
       * Flash message to display after redirect
       *
       * @param to
       * @param msg
       */
      redirectWithMessage (to, msg, type=false, uuid = null) {
        const query = qs.stringify({ flash: msg, success: type, uuid : uuid})
        const url = `${to}?${query}`
        this.$router.push(url)
      }
    }
  }
</script>
<style scoped>
  .hero {
    margin-top: auto;
    margin-bottom: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ActivateAccount.vue